/**
 * What the English voice reads (D-105), without the voice itself: the platform speaks (the
 * browser's speechSynthesis on the web, expo-speech on the phone).
 */

/** Listening scripts, the examiner and the vocabulary are read in British English. */
export const ENGLISH_VOICE = "en-GB";

/** A Listening script « SPEAKER: line » → the lines only (the names are not read aloud). */
export function spokenScript(script: string): string {
  return script
    .split("\n")
    .map((line) => line.replace(/^\s*[A-Z][A-Z .'-]{1,30}:\s*/, "").trim())
    .filter(Boolean)
    .join("\n");
}

/** The best English voice of a list: en-GB first, then any other English one. */
export function pickEnglishVoice<V extends { lang?: string; language?: string }>(list: readonly V[]): V | undefined {
  const lang = (v: V) => (v.lang ?? v.language ?? "").replace("_", "-").toLowerCase();
  return list.find((v) => lang(v) === "en-gb") ?? list.find((v) => lang(v).startsWith("en"));
}
